exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3iLoPb73BkEr8t{display:flex;flex-direction:row;align-items:center;margin:0}._2Q4tBHTmJ5al7o{flex-grow:1;font-size:14px;line-height:24px;padding-right:25px}.XnTLQ0pnjNHrOg{margin:0 0 0 20px;flex-shrink:0}.XnTLQ0pnjNHrOg button{margin-top:0;margin-right:0;cursor:pointer}.XnTLQ0pnjNHrOg button:hover{background-color:#c1c7d0}.XnTLQ0pnjNHrOg button:active{background-color:#b3bac5;color:#172b4d}", ""]);

// exports
exports.locals = {
	"noticeBannerContainer": "_3iLoPb73BkEr8t",
	"textContent": "_2Q4tBHTmJ5al7o",
	"learnMoreButton": "XnTLQ0pnjNHrOg"
};